import { withChartLayout } from 'components/common';
import SafetyAssessment from 'components/features/chart/system-assessment/safety-assessment/SafetyAssessment';

const SafetyAssessmentPage = withChartLayout('Safety Assessment')(SafetyAssessment);
export default SafetyAssessmentPage;
